<template>
  <div class="map-filters-list" :class="{ add: isAddMode }">
    <GamChessFeatureItem v-bind="getLocationFeatureItem('chess_set' as LocationChessFeature)" />
    <GamChessFeatureItem v-bind="getLocationFeatureItem('chess_clock' as LocationChessFeature)" />
    <GamChessFeatureItem v-bind="getLocationFeatureItem('chess_table' as LocationChessFeature)" />
    <GamChessFeatureItem v-bind="getLocationFeatureItem('giant_chess' as LocationChessFeature)" />
  </div>
</template>

<script setup lang="ts">
import type { FilterAttribute } from '@/core/data/filter/filter.interface';
import { LocationChessFeature } from '@/core/data/location/location.type';
import { gambits } from '@/core/gambits';
import GamHelper from '@/core/helpers/app.helper';
import { GamComponentsEmits } from '@/views/composables/constants/main/emit.constants';
import type { GamChessFeatureItemType, GamChessFeatureListType } from '@/views/composables/models/components/GamMap';
import { onMounted, ref } from 'vue';
import GamChessFeatureItem from './GamChessFeatureItem.vue';

const props = defineProps<GamChessFeatureListType>();
const emits = defineEmits([GamComponentsEmits.UPDATE_VALUE, GamComponentsEmits.CLOSE]);

const locationFilters = ref<{ [key: string]: FilterAttribute }>();
const chessFeatures = ref<LocationChessFeature[]>([]);

onMounted(() => {
  getLocationFilters();
  // Quite ugly, but since this is tightly coupled with a generic store, hard to get around now.
  if (props.value) {
    props.value.forEach((type: LocationChessFeature) => {
      toggleType(type);
    });
  }
});

const getLocationFilters = () => {
  // TODO: This is not initialized properly;

  const result = gambits.filterService.getAppFilters();
  if (result) {
    locationFilters.value = result.filters.locations;
  }
};

const toggleType = (type?: LocationChessFeature) => {
  if (!type) return;
  if (chessFeatures.value.includes(type)) {
    if (props.isMultiSelect) {
      GamHelper.removeItem(chessFeatures.value, type);
    } else {
      chessFeatures.value = [];
    }
  } else {
    if (props.isMultiSelect) {
      chessFeatures.value.push(type);
    } else {
      chessFeatures.value = [type];
    }
  }
  if (props.isAddMode) {
    emits(GamComponentsEmits.UPDATE_VALUE, chessFeatures.value);
  } else {
    // filterStore.setFilters({
    //   ...filters.value,
    //   private: undefined,
    //   favorite: undefined,
    //   locationTypes: locationTypes.value,
    // });
    emits(GamComponentsEmits.CLOSE);
  }
};

const getLocationFeatureItem = (option: LocationChessFeature): GamChessFeatureItemType => {
  return {
    feature: option,
    isSelected: chessFeatures.value.includes(option),
    callback: toggleType,
  };
};
</script>

<style scoped lang="scss">
.map-filters-list {
  display: flex;
  flex-direction: column;
  // gap: var(--spacing-md);
  align-self: stretch;
  display: flex;
  flex-direction: row;
  // gap: var(--spacing-md);
  align-self: stretch;

  & > div {
    width: 25%;
    overflow: hidden;
  }

  // &.add {
  //   padding-bottom: var(--spacing-l);
  // }

  .gam-nav-item {
    width: 100%;
  }
}
</style>
